import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * @deprecated use useQueryParams() instead
 */
export const useLocationSearchParams = (): URLSearchParams => {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
};
